import { valueof } from '@flipster/utils/typescript';

export const LaunchpoolStatus = {
  Ongoing: 'ONGOING',
  Upcoming: 'UPCOMING',
  Closed: 'FINISHED',
} as const;

export type LaunchpoolStatusType = valueof<typeof LaunchpoolStatus>;

export interface GetLaunchpoolResponse {
  banners: string[];
  pools: Launchpool[];
  isAbuserOrInternal: boolean;
  isAbuser: boolean;
  earnProgramApr?: string;
}

export interface TradingMultiplier {
  tradingVolume: string;
  multiplier: number;
  displayTextOverride?: string;
}

export interface Multiplier {
  multiplier: number;
  multiplierType:
    | 'MULTIPLIER_TYPE_DEFAULT'
    | 'MULTIPLIER_TYPE_TRADING_VOLUME'
    | 'MULTIPLIER_TYPE_FIRST_DEPOSIT'
    | 'MULTIPLIER_TYPE_CONVERSION_VOLUME'
    | 'MULTIPLIER_TYPE_VIP';
  text: string;
}

export interface ConversionTooltip {
  title: string;
  highlightedTitle: string;
  content: string | null;
  explanations: {
    title: string;
    description: string;
    additionalLink: string;
    additionalLinkTitle: string;
  }[];
}

export interface Launchpool {
  id: number;
  stakingCurrency: string;
  rewardCurrency: string;
  status: LaunchpoolStatusType;
  totalReward: number;
  startAt: string;
  endAt: string;
  estimatedApr?: string;
  estimatedDailyReward?: string;
  isSparkLaunchpool: boolean;
  totalStaked: string;
  stakedAmount: string;
  estimatedReward?: string;
  firstDepositorBannerStatus:
    | 'FIRST_DEPOSITOR_BANNER_STATUS_FIRST_DEPOSITED_BANNER'
    | 'FIRST_DEPOSITOR_BANNER_STATUS_NOT_DEPOSITED_BANNER'
    | 'FIRST_DEPOSITOR_BANNER_STATUS_NO_BANNER';
  minStakableAmount: string;
  maxStakableAmount: string;
  tradingVolume?: string;
  multipliedBy?: number;
  multipliers: Multiplier[];
  vipMultiplier: number;
  isStakable: boolean;
  isUnstakable: boolean;
  autoConversionOn?: true;
  multiplierTooltipOverride?: string;
  volumeTitleOverride?: string;
  volumeCurrencyOverride?: string;
  convertButtonTextOverride?: string;
  conversionTooltip: ConversionTooltip;
  autoConversionTooltip: ConversionTooltip;
  autoConversionSupported: boolean;
  showHedge?: boolean;
  minVipTierForMultiplier: number;
  maximumUsdtApr?: string;
}

export interface GetLaunchpoolHistoryResponse {
  updatedAt?: string;
  histories: LaunchpoolHistory[];
}

export interface LaunchpoolHistory {
  date: string;
  totalStaked: string;
  stakedAmount: string;
  rewardAmount: string;
  multipliedBy?: number;
  tradingVolume?: string;
  isVip: boolean;
  vipTier?: number;
  isExcluded: boolean;
}
